import { Info } from "lucide-react";
import { DISCLOSURE_SHORT } from "../../data/site";

const DisclosureBar = () => (
  <div className="border-b border-white/5 bg-surface/80 px-6 py-2.5" data-testid="affiliate-disclosure-bar">
    <p className="mx-auto flex max-w-6xl items-start gap-2 text-xs leading-relaxed text-white/45">
      <Info className="mt-0.5 h-3.5 w-3.5 shrink-0 text-volt/60" />
      {DISCLOSURE_SHORT}
    </p>
  </div>
);

export default DisclosureBar;
